import { ArrayHelpers } from "@common/ArrayHelpers";
import { Catalog } from "../../types/catalogDefaults"

/**
 * Returns translated catalog name by title
 * @param catalogs info about catalogs
 * @param title catalog title
 * @param lang
 * @returns translated catalog name
 */
export const getTranslatedCatalogPageName = (title: string, catalogs: Catalog[], lang = 'en'): string => {
    const map = ArrayHelpers.keyByWith(catalogs, 'schemaId', 'titles');
    return map[title][lang] ?? map[title]['en'] ?? 'catalog'
}